import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, ClipboardList, User, HelpCircle } from "lucide-react";

// Vibrate pattern for haptic feedback
const vibrate = () => {
  if (navigator.vibrate) navigator.vibrate(10);
};

export default function MobileNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  const tabs = [
    { icon: <Home size={22} />, label: "Home", path: "/welcome" },
    { icon: <ClipboardList size={22} />, label: "Jobs", path: "/your-jobs" },
    { icon: <User size={22} />, label: "Profile", path: "/profile" },
    { icon: <HelpCircle size={22} />, label: "Help", path: "/help" },
  ];

  const hiddenRoutes = [
    "/login",
    "/signup",
    "/complete-profile",
    "/verify-phone",
    "/set-address",
    "/upload-photo",
    "/terms",
    "/customer-dashboard",
    "/ride-payment",
  ];

  // Smooth hide/show on scroll
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;

      if (currentY < lastScrollY.current || currentY < 10) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Hide on specific routes
  if (
    hiddenRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/chat/") ||
    location.pathname.startsWith("/customer/chat/") ||
    location.pathname.startsWith("/support-chat/") ||
    location.pathname.startsWith("/ridechat/")
  ) {
    return null;
  }

  return (
    <div
      className={`
        fixed bottom-0 left-0 right-0
        flex justify-evenly items-center
        py-3 px-2
        backdrop-blur-xl bg-white/80
        border-t border-gray-200/60
        shadow-[0_-6px_30px_rgba(0,0,0,0.15)]
        rounded-t-3xl
        transition-all duration-500 transform-gpu
        ease-[cubic-bezier(0.34,1.56,0.64,1)]
        z-[50]
        ${isVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}
      `}
      style={{
        height: "75px",
      }}
    >
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path;

        return (
          <button
            key={tab.path}
            onClick={() => {
              vibrate();
              navigate(tab.path);
            }}
            className={`
              flex flex-col items-center justify-center 
              px-4 py-2 
              transition-all duration-300 ease-out
              ${
                isActive
                  ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white scale-110 shadow-xl"
                  : "text-gray-700 hover:text-blue-600"
              }
              rounded-2xl
            `}
            style={{ minWidth: "70px" }}
          >
            <div
              className={`transition-transform duration-300 ${
                isActive ? "translate-y-[-4px]" : ""
              }`}
            >
              {tab.icon}
            </div>
            <span
              className={`text-[11px] mt-1 font-semibold ${
                isActive ? "text-white" : "text-gray-700"
              }`}
            >
              {tab.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
